import { render, staticRenderFns } from "./FUNItem.vue?vue&type=template&id=bec8a5fc"
import script from "./FUNItem.vue?vue&type=script&lang=js"
export * from "./FUNItem.vue?vue&type=script&lang=js"
import style0 from "./FUNItem.vue?vue&type=style&index=0&id=bec8a5fc&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bec8a5fc')) {
      api.createRecord('bec8a5fc', component.options)
    } else {
      api.reload('bec8a5fc', component.options)
    }
    module.hot.accept("./FUNItem.vue?vue&type=template&id=bec8a5fc", function () {
      api.rerender('bec8a5fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Study/FUNItem.vue"
export default component.exports